
import { Component, Vue, Prop } from 'vue-property-decorator';
import stores from '@/stores';
import { SweetModal } from 'sweet-modal-vue';
import {showToaster} from "@/components/DashboardComposer/helpers";
import {translate} from "@/helpers/functions";

@Component({
 components: {
   SweetModal,
 },
})

export default class CreateCategory extends Vue {
  @Prop()
  module!: IModule;

  newItem = {
    id: null,
    active: true,
    name: '',
    imageId: null,
    moduleId: null,
    sort: null,
    type: 'APP',
  };

  nameRules = {};

  submitNewItem() {
    if (this.newItem) {
      return this.module.createNewItem!((this.newItem))
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error.message);
          }

          showToaster('success', this.newItem.name, translate('successfully-created'));
          this.$router.push({name: `${this.module.path}.items.show`, params: {id: response.data.id}});
          this.cancel();
        })
        .catch((e) => {
          console.log(e);
          showToaster('danger', '', e);
        });
    }
  }
  cancel() {
    (document.getElementById('create-form') as HTMLFormElement).classList.remove('was-validated');
    // @ts-ignore
    this.$children[0].close();
  }

  mounted() {
    // @ts-ignore
    this.newItem.type = (this.$options.propsData.module.type === 'TV_APPLICATION') ? 'APP' :'WEBSITE';
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const form = document.getElementById('create-form') as HTMLFormElement;
    form.addEventListener('submit', (event: any) => {
      event.preventDefault();
      if (form.checkValidity() === true) {
        event.stopPropagation();
        this.submitNewItem();
      }
      if (form.checkValidity() === false) {
        event.stopPropagation();
      }
      form.classList.add('was-validated');
    }, false);
  }
}
